import { render, staticRenderFns } from "./featuredSponsorsEdition.vue?vue&type=template&id=62b6d7f8"
import script from "./featuredSponsorsEdition.vue?vue&type=script&lang=js"
export * from "./featuredSponsorsEdition.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports